import { PureComponent } from 'react';
import clickOutside from '../higherOrderComponents/clickOutside';
import { Button, Input } from 'antd';
import { uploadFileClick } from './uploadFile';
import GooglePicker from './googlePicker';
// import OneDrivePicker from './oneDrivePicker';
import DropboxChooser from './dropboxChooser';
import URLChooser from './URLChooser';
import i10n from '../../../common/i10n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AsyncSVG } from '../AsyncSVG';
import { getDownloadSVGFileIconByExtension } from '../../helpers/fileHelper';

class UploadMoreButton extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            showMethods: false,
            isUrlEntry: false
        };
    }

    onClickOutside = () => {
        this.showUploadMethods(false);
    }

    uploadFileClick = (fromDevice) => {
        if (this.props.beforeClick) {
            this.props.beforeClick();
        }

        if (fromDevice) {
            uploadFileClick();
        }

        this.showUploadMethods(false);

        if (this.props.afterClick) {
            this.props.afterClick();
        }
    }

    showUploadMethods = (flag) => {
        this.setState({
            showMethods: flag
        });
    }

    render() {
    
        return (
            <div className={this.props.className}>
                {
                    !this.state.isUrlEntry &&
                    <div>
                        <Button className={`action-button upload-more ${this.props.buttonBackground}`} onClick={() => { this.showUploadMethods(!this.state.showMethods); }}>
                            <AsyncSVG className={"upload-more-icon rounded-icon"} src={this.props.folderImg ? '/images/upload-folder.svg' : '/images/black-avepdf-svg-upload.svg'}/>
                            {this.props.title || i10n._VIEW_TOOL_LAYOUT_UPLOAD_MORE_FILES}
                        </Button>
                        <div className="upload-more-methods" style={{ display: this.state.showMethods ? 'block' : 'none' }}>
                            <ul>
                                {
                                    this.props.previousProcessedContext &&
                                    <li onClick={() =>  this.props.onPreviousProcessedContext(this.props.previousProcessedContext.id)}>
                                    <div>
                                        <Button aria-label="Upload More" className={`action-button ${this.props.buttonBackground}`}>
                                            <span>
                                                <AsyncSVG className="cloud-upload-icon" src={getDownloadSVGFileIconByExtension(this.props.previousProcessedContext.outputFileName)} />
                                                <span className="upload-more-label">{this.props.previousProcessedContext.outputFileName}</span>
                                            </span>
                                        </Button>
                                    </div>
                                </li>
                                }
                                <li onClick={() => { this.uploadFileClick(true); }}>
                                    <div>
                                        <Button aria-label="Upload More" className={`action-button ${this.props.buttonBackground}`}>
                                            <span>
                                                <AsyncSVG className="cloud-upload-icon" src="/images/upload-folder.svg" />
                                                <span className="upload-more-label">{this.props.folderUploadButton}</span>
                                            </span>
                                        </Button>
                                    </div>
                                </li>
                                <li onClick={() => { this.uploadFileClick(false); } }>
                                    <GooglePicker
                                        buttonBackground={this.props.buttonBackground}
                                        multiselect={this.props.multipleFiles}
                                        types={this.props.fileTypes?.ext}
                                        onFilesPicked={this.props.onFilesChosen}
                                        onError={this.props.onError}
                                    >
                                        <span className="upload-more-label">{i10n._VIEW_UPLOAD_UPLOAD_MORE_FROM_GOOGLEDRIVE}</span>
                                    </GooglePicker>
                                </li>
                                <li onClick={() => { this.uploadFileClick(false); }}>
                                    <DropboxChooser
                                        buttonBackground={this.props.buttonBackground}
                                        multiselect={this.props.multipleFiles}
                                        extensionsArray={this.props.fileTypes.ext?.toLowerCase().split(',')}
                                        onFilesDownloaded={this.props.onFilesChosen}
                                        onError={this.props.onError}
                                    >
                                        <span className="upload-more-label">{i10n._VIEW_UPLOAD_UPLOAD_MORE_FROM_DROPBOX}</span>
                                    </DropboxChooser>
                                </li>
                                {
                                    //<li onClick={() => { this.uploadFileClick(false); } }>
                                    //    <OneDrivePicker
                                    //        buttonBackground={this.props.buttonBackground}
                                    //        multiselect={this.props.multipleFiles}
                                    //        types={this.props.fileTypes.toLowerCase().split(',')}
                                    //        onFilesPicked={this.props.onFilesChosen}
                                    //        onError={this.props.onError}>
                                    //        <span className="upload-more-label">{i10n._VIEW_UPLOAD_UPLOAD_MORE_FROM_ONEDRIVE}</span>
                                    //    </OneDrivePicker>
                                    //</li>
                                }
                                {
                                    this.props.showUploadViaURI &&
                                    <li onClick={() => { this.uploadFileClick(false); this.setState({ isUrlEntry: !this.state.isUrlEntry }); }}>
                                        <URLChooser buttonBackground={this.props.buttonBackground} >
                                            <span className="upload-more-label">{i10n._VIEW_UPLOAD_UPLOAD_MORE_FROM_REMOTE}</span>
                                        </URLChooser>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                }
                {
                    this.state.isUrlEntry &&
                    <Input
                        className="upload-url-input"
                        type="text"
                        minLength={1}
                        placeholder={"https://www.example.com/file.pdf"}
                        addonBefore={<div className="url-input-icon"><FontAwesomeIcon icon={faGlobe} size="2x" title="world wide web" /></div>}
                        addonAfter={
                            <div className="rename-on">
                                <Button className="url-cancel-btn" onClick={() => this.setState({ isUrlEntry: false })}><FontAwesomeIcon icon={faTimes} size="1x" title="abort" /></Button>
                                <Button className="ant-btn-primary" onClick={this.props.downloadFromUrl}><FontAwesomeIcon icon={faCheck} size="1x" title="validate" /></Button>
                            </div>
                        }
                        onPressEnter={this.props.downloadFromUrl}
                        onChange={e => this.props.onUriInputChange(e.target.value)}
                    />
                }
            </div>
        );
    }
}

const ClickOutsideUploadMoreButton = clickOutside(UploadMoreButton, "upload-more-button-wrapper mt-2 mx-3");
export default ClickOutsideUploadMoreButton;